import { ReactNode } from "react";
import cx from "classnames";

import CardWrapper from "ds/components/Card/components/Wrapper";
import { IconComponent } from "types/Icon";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

export type SystemMessageCardProps = {
  title: string;
  message: ReactNode;
  icon?: IconComponent;
  children?: ReactNode;
  className?: string;
};

const SystemMessageCard = ({
  title,
  message,
  icon,
  children,
  className,
}: SystemMessageCardProps) => {
  const cardClassName = cx(styles.cardWrapper, className);

  return (
    <CardWrapper gap="x-large" padding="xx-large" surfaceColor="primary" className={cardClassName}>
      {icon && (
        <Box justify="center">
          <Icon src={icon} size="x-large" />
        </Box>
      )}

      <Box direction="column" gap="small">
        <Typography tag="h1" variant="p-t6" align="center">
          {title}
        </Typography>
        {message && (
          <Typography tag="p" variant="p-body3" align="center">
            {message}
          </Typography>
        )}
      </Box>

      {children}
    </CardWrapper>
  );
};

export default SystemMessageCard;
